import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { LoaderScreen } from '@grandvisionhq/common';
import { useRedirects } from '../../hooks/use-redirects.js';

const RedirectionWrapper = ({ redirect , email , orderNumber  })=>{
    const { redirectToLogin , redirectToConfirmation  } = useRedirects({
        message: redirect.reason
    });
    React.useEffect(()=>{
        const performRedirect = function() {
            var _ref = swcHelpers.asyncToGenerator(function*() {
                switch(redirect.page){
                    case 'login':
                        {
                            redirectToLogin();
                            break;
                        }
                    case 'confirmation':
                        {
                            yield redirectToConfirmation({
                                email,
                                orderNumber
                            });
                            break;
                        }
                }
            });
            return function performRedirect() {
                return _ref.apply(this, arguments);
            };
        }();
        performRedirect();
    }, [
        email,
        orderNumber,
        redirect,
        redirectToConfirmation,
        redirectToLogin
    ]);
    return /*#__PURE__*/ React.createElement(LoaderScreen, null);
};

export { RedirectionWrapper };
//# sourceMappingURL=RedirectionWrapper.js.map
